import { GzFirewallAdvancedWebComponent } from './component/GzFirewallAdvancedWebComponent';

export { GzFirewallAdvancedWebComponent };
